if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.idInput = this.form.querySelector("[name=id]");
        this.idInput.disabled = false;

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (this.querySelector(".btn-show-shades")) {
          this.querySelector(".btn-show-shades").addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              this.classList.toggle("show");
            }
          );
        }

        this.submitButton = this.querySelector(".product-card__btn--add");
        if (this.submitButton) {
          this.submitButton.addEventListener("click", (e) => this.onSubmit(e));
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
      }

      onSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        //delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        var data = [];
        const mainProduct = formData.get("id");

        // formData.append("sections", "dropdown-cart");
        // formData.append("sections_url", window.location.pathname);

        // const includes = formData.getAll("includes");
        const includes = formData.getAll("includes");

        if (includes.length > 0) {
          includes.forEach((include) => {
            const includeData = {
              id: include,
              properties: {},
            };

            if (
              this.form.querySelector(`[value="${include}"]`).dataset.property
            ) {
              includeData.properties = JSON.parse(
                this.form.querySelector(`[value="${include}"]`).dataset.property
              );
            }
            includeData.properties["_included_in"] = mainProduct;
            includeData.properties["_includes"] = includes.toString();
            data.push(includeData);
          });
        }

        if (mainProduct) {
          const productData = {
            id: mainProduct,
            quantity: 1,
            properties: {},
          };
          if (this.idInput.dataset.property) {
            productData.properties = JSON.parse(this.idInput.dataset.property);
          }
          if (includes.length > 0) {
            productData.properties["_includes"] = includes.toString();
          }
          data.push(productData);
        }

        config.body = JSON.stringify({ items: data });

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            //document.querySelector("[data-cart-toggle]").click();
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
